import { Close } from "../../assets/svgs";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const CampaignHeader = ({
  onClick,
  logoStyle = {},
  btnStyle = {},
  hideBtn = false,
  darkLogo,
  containerStyle = {},
  isCrossButton,
  onClickClose,
}) => {
  const { selectedLanguage, tenantConfig, isRTL } = useApp();
  return (
    <div className="campaign-header" style={{ ...containerStyle }}>
      <img
        src={
          darkLogo
            ? tenantConfig?.logo?.content?.dark
            : tenantConfig?.auth_logo?.content?.default
        }
        alt="logo"
        className="auth-logo"
        style={{ ...logoStyle }}
      />

      {!hideBtn ? (
        <button
          className="language-button"
          style={{ ...btnStyle }}
          onClick={() => {
            onClick();
          }}
        >
          {selectedLanguage?.value === "ar" ? "English" : "العربية"}
        </button>
      ) : null}
      {isCrossButton ? (
        <img
          src={Close}
          onClick={onClickClose}
          alt="close-icon"
          className={isRTL ? "close-icon-rtl" : "close-icon"}
        />
      ) : null}
    </div>
  );
};

export default CampaignHeader;
